/**
 * Cookie reader for CSRF tokens. The `__Host-mf_csrf` cookie is intentionally
 * readable by JavaScript (double-submit pattern); it is not HttpOnly.
 */

export function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const prefix = `${name}=`;
  for (const part of document.cookie.split(";")) {
    const entry = part.trim();
    if (entry.startsWith(prefix)) {
      return decodeURIComponent(entry.slice(prefix.length));
    }
  }
  return null;
}
